import React from 'react'
import { ErrorMessageProps, useField } from 'formik'
import styled from 'styled-components'

const ErrorBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-basis: 100%;
  color: #f00;
  font-size: 0.875rem;
  line-height: 1.125rem;
`

export const ErrorTextMessage: React.FC<ErrorMessageProps> = ({ name }: ErrorMessageProps) => {
  const [_field, meta] = useField(name) // eslint-disable-line @typescript-eslint/no-unused-vars

  return meta?.touched && meta?.error ? (
    <ErrorBlock>
      <span>{meta.error}</span>
    </ErrorBlock>
  ) : null
}
